module.exports = __webpack_public_path__ + "static/media/some-luna-noah-nologo.5cdb344c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/HomePage/static/some-luna-noah-nologo.png
// module id = 149
// module chunks = 0